import { CheckOutlined, FormOutlined } from '@ant-design/icons';
import { Rate } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { Link, useFetcher, useLoaderData } from 'react-router-dom';
import { generateRouteUrl } from "../../../library/constants/routes.js";
import { Image } from '../../../ui';
import { ManualProductTag } from '../../design';
import { getProductImageUrl } from '../../../library/helpers/product_url.js';
import ProjectItemSpecifications from "../project-item/specifications.js";
import styles from './item.module.scss';

const ItemDetailsSection = ({ readOnly = true }) => {
    const { orderDetails, productDetails, itemDetails } = useLoaderData()
    const fetcher = useFetcher()
    const [isEditable, setIsEditable] = useState(false)
    // Supplier first (existing behavior), finisher fallback: finisher-driven
    // orders set finisher_id without vendor_selected_id.
    const displayVendor = itemDetails.selected_vendor || itemDetails.selected_finisher || null

    const handleSpecificationsChange = (specs) => {
        fetcher.submit({
            specs,
            action: 'updateSelectedSpecs'
        }, {
            method: 'post',
            encType: 'application/json'
        })
    }
    const handleCustomSpecificationAdd = (data) => {
        fetcher.submit({
            ...data,
            action: 'customSpecification'
        }, {
            encType: 'application/json',
            method: 'post'
        })
    }
    const handleCustomSpecificationUpdate = (specId, data) => {
        fetcher.submit({
            ...data,
            specId: specId,
            action: 'customSpecification'
        }, {
            encType: 'application/json',
            method: 'patch'
        })
    }
    const handleCustomSpecificationDelete = (specId) => {
        fetcher.submit({
            specId,
            action: 'customSpecification'
        }, {
            encType: 'application/json',
            method: 'delete'
        })
    }
    const handleHiddenSpecificationChange = async (specId, selected) => {
        fetcher.submit({
            specId,
            action: 'hiddenSpecification'
        }, {
            encType: 'application/json',
            method: selected ? 'post' : 'delete'
        })
    }
    const handleHiddenSpecificationValueChange = async (specId, value) => {
        fetcher.submit({
            specId,
            value_text: value,
            action: 'hiddenSpecification'
        }, {
            encType: 'application/json',
            method: 'patch'
        })
    }
    const handleOrderChange = (specs, customSpecs) => {
        fetcher.submit({
            specs,
            action: 'updateSelectedSpecs'
        }, {
            method: 'post',
            encType: 'application/json'
        })
        fetcher.submit({
            customSpecs,
            action: 'sortSpecifications'
        }, {
            method: 'post',
            encType: 'application/json'
        })
    }

    const handleDetailsChagne = (data) => {
        fetcher.submit({
            ...data,
            action: 'updateOrderDetails'
        }, {
            method: 'post',
            encType: 'application/json',
        })
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <h2 className={styles.title}>{orderDetails.product.name}<ManualProductTag product={orderDetails.product} /></h2>
                <div className={`box--white ${styles.image}`}>
                    <Image
                        src={orderDetails.product.main_photos?.[0] ? getProductImageUrl(orderDetails.product.main_photos[0]) : ''}
                        fallback="data:image/png;base64,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"
                    />
                </div>
                <i>Image is for illustration.Real product may vary</i>
            </div>
            <div className={styles.right}>
                {displayVendor && (
                    <>
                        <Link className={styles.title} to={generateRouteUrl('VendorUpdate', {
                            id: displayVendor.id
                        })}>{displayVendor.company}</Link>
                        ( <Rate disabled /> )
                    </>
                )}
                <div className="box--light-gray">
                    <div className={styles.specificationsTitle}>
                        <h3>Specifications</h3>
                        {!orderDetails.isInProduction && (
                            (readOnly == true && <a onClick={() => setIsEditable(s => !s)}>
                                {isEditable ? <CheckOutlined /> : <FormOutlined />}
                            </a>)
                        )}
                    </div>
                    <ProjectItemSpecifications
                        itemId={itemDetails.itemId}
                        quantity={itemDetails.approved_quantity}
                        inbuiltSpecifications={productDetails.specifications}
                        deletedInbuiltSpecificationIds={itemDetails.deleted_spec_ids}
                        customSpecifications={itemDetails.item_custom_specifications || []}
                        specificationValues={Object.values(itemDetails.specifications)}
                        hiddenSpecifications={productDetails.hiddenspecifications}
                        hiddenSpecificationValues={itemDetails.item_hidden_specifications}
                        max_print_area_size={itemDetails.max_print_area_size}
                        print_position={itemDetails.print_position}
                        onSpecificationsChange={handleSpecificationsChange}
                        onCustomSpecificationAdd={handleCustomSpecificationAdd}
                        onCustomSpecificationUpdate={handleCustomSpecificationUpdate}
                        onCustomSpecificationDelete={handleCustomSpecificationDelete}
                        onOrderChange={handleOrderChange}
                        onHiddenSpecificationUpdate={handleHiddenSpecificationChange}
                        onHiddenSpecificationValueChange={handleHiddenSpecificationValueChange}
                        onDetailsChange={handleDetailsChagne}
                        readonly={!isEditable}
                    />
                </div>
            </div>
        </div>
    );
}

ItemDetailsSection.propTypes = {
    readOnly: PropTypes.bool
}

export default ItemDetailsSection